module.exports = __webpack_public_path__ + "static/img/top_back_img.972ab01.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/rm_brand_img/top_back_img.png
// module id = OeuR
// module chunks = 1